module.exports = __webpack_public_path__ + "static/media/Inter-MediumItalic.fe68865a.woff2";